export function initSplineLock(selector = '#spline-hero') {
    const wrap = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!wrap) return null;

    wrap.style.touchAction = 'pan-y';

    let canvas = wrap.querySelector('canvas');
    if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.style.pointerEvents = 'auto';
        canvas.style.touchAction = 'pan-y';
        canvas.style.outline = 'none';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        wrap.appendChild(canvas);
    }

    import('./spline-embed.js')
        .then((module) => {
            if (module.launchSpline) {
                module.launchSpline(canvas);
            }
        })
        .catch((err) => console.error('Erreur import Spline:', err));

    return {
        el: wrap,
        destroy: () => {}
    };
}